<script setup lang="ts">
import PoliciesPage from '@/pages/policies';
</script>

<template>
  <PoliciesPage />
</template>
